import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { CSSTransitionGroup } from 'react-transition-group'

import './css/Home.css'
import Background1 from './assets/home-1.jpg'
import Background2 from './assets/home-2.jpg'
import HomeText from './text/home-text'
import InviteForm from './InviteForm'

const DegreeItems = ['GRADUATE SCHOOLS', `MBA'S`, `JD'S`, 'ONLINE COURSES', 'CERTIFICATE PROGRAM', 'ADULT EDUCATION', `PHD'S`]
const ImageIndex = {
  One: 1,
  Two: 2
}

class Home extends Component {
  refHandlers = {
    headerImage: el => this.headerImage = el
  }

  constructor(props) {
    super(props)
    this.state = {
      idx: ImageIndex.One,
      isSmallScreen: false
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  }

  componentDidMount() {
    this.interval = setInterval(this.setImageIdx, 5000)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }

  onResize = ev => {
    let isSmallScreen = window.innerWidth < 800 ? true : false
    this.setState({
      isSmallScreen
    })
  }

  setImageIdx = () => {
    let idx = this.state.idx === ImageIndex.One ? ImageIndex.Two : ImageIndex.One
    let background = idx === 1 ? Background1 : Background2
    this.headerImage.style.background = `url(${background}) center no-repeat`
    this.headerImage.style.backgroundSize = 'cover'
    this.setState({ idx })
  }

  renderDegreeItem = text => (
    <div key={text} className="degree-item">{text}</div>
  )
  
  renderDegrees = () => (
    <div className="degree-listing">
      {this.state.isSmallScreen ? <div>You have options...</div> : null}
      {DegreeItems.map(this.renderDegreeItem)}
    </div>
  )

  renderHomeNavbar = () => (
    <div className="home-navbar">
      <div className="home-navbar-unit">
        <Link to="/">HOME</Link>
      </div>
      <div className="home-navbar-unit">
        <Link to="/about">ABOUT</Link>
      </div>
      <div className="home-navbar-unit">
        <Link to="/how">HOW IT WORKS</Link>
      </div>
      <div className="home-navbar-unit">
        <Link to="/invite">GET THE INVITE</Link>
      </div>
    </div>
  )

  renderHomeText = text => (
    <div key={text} className="text-padding">{text} <br /></div>
  )

  render() {
    let { isSmallScreen } = this.state

    return (
      <div className="home-container">
        <CSSTransitionGroup
          transitionName="fade"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionLeaveTimeout={500}
          transitionEnter={false}
          transitionLeave={true}>
        <div className="home-header top"
          ref={this.refHandlers.headerImage}>
          <div className="header-main center">
            <div className="logo" />
            <div className="header">
                {HomeText[0]}<br />
                WE’LL TELL YOU WHERE TO GO.
              </div>
            <div className="small-header small-text white">{HomeText[1]}</div>
            <div className="yellow-button orange-button">
              <Link to="/invite">GET YOUR INVITATION</Link>
            </div>
          </div>
        </div>
        {this.renderHomeNavbar()}
        </CSSTransitionGroup>  
        <CSSTransitionGroup
          transitionName="slide"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionLeaveTimeout={500}
          transitionEnter={false}
          transitionLeave={true}>
          <div className="home-body">
            <div className="home-body-left">
              <div className="header-1">{HomeText[2]}</div>
              {isSmallScreen ? this.renderDegrees() : null}
              <div className="medium-text text-padding">{HomeText[3]}</div>
              <div className="home-body-indent">
                {HomeText.slice(4, 9).map(this.renderHomeText)}
              </div>
              <div className="text-padding center">
                {HomeText[9]} <br />
                {HomeText[10]}
              </div>
            </div>
            <div className="home-body-right">
              {isSmallScreen ? null : this.renderDegrees()}
              <InviteForm />
            </div>
          </div>
        </CSSTransitionGroup>  
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// src/Home.js